import { Common } from './common';
import { Pagination } from './models/common';

import * as Pharmacy from './models/pharmacy';
import { ImportValidation } from './models/provider';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    args: Pharmacy.FindAllOptions,
  ): Promise<Pagination<Pharmacy.PharmacyWithAddress>> {
    const url = this.common.constructPath(`/pharmacies`, args);
    return this.common.getJSON(url);
  }

  async import(
    pharmacies: Partial<
      Omit<Pharmacy.PrevisitPharmacy, 'id' | 'staticMapUrl'>
    >[],
  ): Promise<Pharmacy.Pharmacy[]> {
    const url = this.common.constructPath(`/pharmacies`);
    return this.common.putJSON(url, { pharmacies: pharmacies });
  }

  async verifyImport(
    values: Record<string, string>[],
  ): Promise<Record<string, ImportValidation>[]> {
    const url = this.common.constructPath(`/pharmacies/import/verify`);
    return this.common.postJSON(url, values);
  }

  async findVerifiedPharmacies(args: {
    page: number;
    limit: number;
    state?: string;
  }): Promise<Pharmacy.PrevisitPharmacy[]> {
    const url = this.common.constructPath(`/patient-previsit/pharmacies`, args);
    return this.common.getJSON(url);
  }
}
